import { updateObject } from "../../../components/shared/utility";

const initialState = {
  region: "",
  openRegionModal: false,
  confirmedRegion: "",
  error: null
};

export default function(state = initialState, action) {
  const LoadRegion = (state, action) => {
    return updateObject(state, {
      region: action.regionFromLink,
      confirmedRegion: action.confirmedRegion,
      openRegionModal:
        action.confirmedRegion === null || action.confirmedRegion === ""
    });
  };

  const PostSelectedRegion = (state, action) => {
    return updateObject(state, {
      region: action.data,
      openRegionModal: false,
      confirmedRegion: action.data
    });
  };

  switch (action.type) {
    case "REGION_ACQUIRED":
      return LoadRegion(state, action);
    case "REGION_SELECTED":
      return PostSelectedRegion(state, action);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/Regions/regionReducer.js